import {Button} from 'components/system'
import {get} from 'lodash'
import {useCallback} from 'react'

type Props = {
  config: object
}

export const SLT = ({config}: Props) => {
  const onClick = useCallback(() => {
    window.open(get(config, 'button.link', ''), '_blank')
  }, [config])

  return (
    <div className="flex flex-col gap-4">
      <img src={get(config, 'image.url', '')} alt={get(config, 'image.alt', '')} className="w-full h-auto rounded-lg" />
      <div className="font-bold text-xl">{get(config, 'title', '')}</div>
      <div className="text-md">{get(config, 'description', '')}</div>
      <Button.Primary.Orange onClick={onClick}>{get(config, 'button.text', '')}</Button.Primary.Orange>
    </div>
  )
}
